import * as yup from "yup";

export const WCBAllProvincesCodeSetupValidationSchema = yup.object().shape({
 
});
